import React from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import {ProjectSession} from "../../../../../../../core/gd-model/project-session/project-model-session"

import {EntityType} from "../../../../../../../core/gd/const/item"
import {SelectParent_RenderType} from "../../../../../../../core/gd-ui/select-parent-new/@const"
import SelectParentNew from "../../../../../../../core/gd-ui/select-parent-new/select-parent-new"

type FilteredProjects = {
    item            : ProjectSession
    notSelectable   : boolean
}

type Props = {
    projectId?          : ID | null
    form                : FormManager

    filterProjects      : FilteredProjects[]

    allowRootSelection  : boolean

    onParentSelected    : callback
}

export default function FormParentSelector(props: Props) {

    const allowRootSelection = _.get(props, 'allowRootSelection', true)

    const parentValue = props.projectId ? props.projectId : null;

    // const parentValue = companiesSelectable || props.projectId ? {
    //     companyId: gd.companyId,
    //     projectId: props.projectId
    // } : null;

    return (
        <div className="row">
            <div className="label">Parent</div>
            <div className="element">
                <SelectParentNew projectId                  = {parentValue}
                                 parentsFor                 = {EntityType.PROJECT}
                                 renderType                 = {SelectParent_RenderType.FORM}
                                 displayWorkspaceRoot       = {allowRootSelection}
                                 canBeNull                  = {allowRootSelection}
                                 onChange                   = {props.onParentSelected}/>

                <FormError form={props.form} name="company" />
                <FormError form={props.form} name="parentProject" />
            </div>
        </div>
    );
}
